const callbackPromise = new Promise((res, rej) => {
  window._resolveGoogleMapsApi = res;
  window._rejectGoogleMapsApi = rej;
});

let initCalled = false;

export const loadGoogleMapsAPI = async ({ apiKey }) => {
  if (!initCalled) {
    const script = document.createElement('script');
    script.addEventListener('error', window._rejectGoogleMapsAPI);
    script.src = `https://maps.googleapis.com/maps/api/js?${apiKey ? `key=${apiKey}&` : ''}callback=_resolveGoogleMapsApi`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    initCalled = true;
  }
  await callbackPromise;
  return window.google.maps;
};
